module.exports = __webpack_public_path__ + "img/pending_zone_selected.33a39b61.svg";